import {
  FunctionList,
  type AdminContentDurationResult,
  type AdminFeedbackResultsResult,
  type AdminOfflineDownloadsCountResult,
  type AdminSetUserMailVerifiedResult,
  type AdminUserDocumentReportResult,
  type AdminUserLookupRequest,
} from "@repo/common";

import { typedHttpsCallable } from "lib/typed-https-callable";

export const fetchAdminContentDuration = async (): Promise<AdminContentDurationResult> => {
  return typedHttpsCallable<AdminContentDurationResult>({
    functionName: FunctionList.AdminGetContentDuration,
    data: {},
  });
};

export const fetchAdminOfflineDownloadsCount = async (): Promise<AdminOfflineDownloadsCountResult> => {
  return typedHttpsCallable<AdminOfflineDownloadsCountResult>({
    functionName: FunctionList.AdminGetOfflineDownloadsCount,
    data: {},
  });
};

export const fetchAdminFeedbackResults = async (): Promise<AdminFeedbackResultsResult> => {
  return typedHttpsCallable<AdminFeedbackResultsResult>({
    functionName: FunctionList.AdminGetFeedbackResults,
    data: {},
  });
};

export const setAdminUserMailVerified = async (identifier: string): Promise<AdminSetUserMailVerifiedResult> => {
  const data: AdminUserLookupRequest = { identifier: identifier.trim() };

  return typedHttpsCallable<AdminSetUserMailVerifiedResult>({
    functionName: FunctionList.AdminSetUserMailVerified,
    data,
  });
};

export const fetchAdminUserDocumentReport = async (identifier: string): Promise<AdminUserDocumentReportResult> => {
  const data: AdminUserLookupRequest = { identifier: identifier.trim() };

  return typedHttpsCallable<AdminUserDocumentReportResult>({
    functionName: FunctionList.AdminGetUserDocumentReport,
    data,
  });
};
